import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { isDemoMode } from "../demo/demoMode";

const demoKey = "plutonic-demo-therapist-progress";

export default function useTherapistProgress() {
  const [record, setRecord] = useState({ progress: {}, uploads: [], auditLog: [] });

  useEffect(() => {
    if (isDemoMode) {
      const saved = JSON.parse(localStorage.getItem(demoKey) || "null");
      setRecord(saved || { progress: {}, uploads: [], auditLog: [] });
      return;
    }
    axios.get("/api/therapist-admin/progress", { withCredentials: true })
      .then(({ data }) => setRecord(data))
      .catch(() => {});
  }, []);

  const update = useCallback(async (area, section, changes) => {
    const payload = { area, itemId: section.id, title: section.title, ...changes };
    if (isDemoMode) {
      setRecord((current) => {
        const key = `${area}:${section.id}`;
        const previous = current.progress[key] || { area, itemId: section.id, title: section.title };
        const now = new Date().toISOString();
        const nextItem = { ...previous };
        if (changes.opened && !nextItem.openedAt) nextItem.openedAt = now;
        if (Object.prototype.hasOwnProperty.call(changes, "completed")) {
          nextItem.completed = changes.completed;
          nextItem.completedAt = changes.completed ? now : null;
        }
        if (changes.videoWatched) {
          nextItem.videoWatched = true;
          nextItem.videoWatchedAt = now;
        }
        const next = { ...current, progress: { ...current.progress, [key]: nextItem }, updatedAt: now };
        localStorage.setItem(demoKey, JSON.stringify(next));
        return next;
      });
      return;
    }
    const { data } = await axios.patch("/api/therapist-admin/progress", payload, { withCredentials: true });
    setRecord(data);
  }, []);

  return { record, update };
}
